import React from 'react';
import Header from "../components/Header";
import Hero from "../components/Profile";
import AboutMe from "../components/AboutMe";
import Skills from "../components/Skills";
import Experience from "../components/Experience";
import Footer from "../components/Footer";
import Service from "../components/services";
import MouseGlow from "../components/MouseGlow";
import ScrollToTop from "../components/ScrollToTop";
import LoadingScreen from "../components/LoadingScreen";
import EmailDemo from "../components/EmailDemo";

const HomePage = () => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <LoadingScreen />
      <MouseGlow /> 
      <Header />
      <ScrollToTop />
      <EmailDemo />
      <div className="pt-20"> {/* Add padding for fixed header */}
        <div id="hero">
          <Hero />
        </div>
        <div id="about">
          <AboutMe />
        </div>
        <div id="skills">
          <Skills />
        </div>
        <div id="experience">
          <Experience />
        </div>
        <div id="services">
          <Service />
        </div>
        <div id="contact">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default HomePage;